import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ShopLegacyRedirect = () => {
  const { orgId, '*': rest } = useParams();
  const [slug, setSlug] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/public/organization/${orgId}`)
      .then((res) => {
        if (cancelled) return;
        if (res.data?.slug) setSlug(res.data.slug);
        else setFailed(true);
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [orgId]);

  if (failed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-center p-6">
        <p className="text-slate-500">Deze webshop bestaat niet (meer).</p>
      </div>
    );
  }

  if (!slug) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-pulse flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-teal-200"></div>
        </div>
      </div>
    );
  }

  return <Navigate to={`/${slug}/shop${rest ? `/${rest}` : ''}`} replace />;
};

export default ShopLegacyRedirect;
